import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f5444fc4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f5444fc4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5444fc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\haima\\mer_mer_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5444fc4')) {
      api.createRecord('f5444fc4', component.options)
    } else {
      api.reload('f5444fc4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f5444fc4&scoped=true", function () {
      api.rerender('f5444fc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadFrom/index.vue"
export default component.exports